import styled from 'styled-components'

interface FlexDivProps {
  dir?: 'column' | 'row';
  align?: string;
  justify?: string;
  maxWidth?: string;
  minWidth?: string;
  gap?: string;
  margin?: string;
  padding?: string;
  height?: string;
}

export const FlexDiv = styled.div<FlexDivProps>`
  width: 100%;
  max-width: ${props => props.maxWidth ?? '100%'};
  min-width: ${props => props.minWidth ?? 'unset'};
  height: ${props => props.height ?? '100%'};
  display: flex;
  flex-direction: ${props => props.dir ?? 'row'};
  align-items: ${props => props.align ?? 'flex-start'};
  justify-content: ${props => props.justify ?? 'flex-start'};
  gap: ${props => props.gap ?? '0'};
  margin: ${props => props.margin ?? '0'};
  padding: ${props => props.padding ?? '0'};
`

export const AdminPortalApplications = styled.main`
  width: 100%;
  height: 100%;
  padding: 64px 48px;
  display: flex;
  flex-direction: column;

  header {
    width: 100%;
    display: flex;
    flex-direction: column;

    nav {
      width: 100%;
      border-bottom: 2px solid #C8C8C8;
    }

    section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 30px 0 48px;
    }
  }

  .pagination-container {
    margin-top: 48px;
  }
`

export const PortalNavTab = styled.button<{ selected?: boolean }>`
  background: inherit;
  border: 0;
  border-bottom: ${props => props.selected ? '8px solid #3D6666' : 0};
  padding: 0 48px 10px;
  margin-bottom: -4px;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  color: ${props => props.selected ? '#3D6666' : '#7B7C82'};
`

export const BulkSelectOptions = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
`

export const TextMessage = styled.h5`
  font-weight: 800;
  font-size: 20px;
  line-height: 27px;
  color: #65666A;
  margin: 48px 0 0 24px;
`

export const OrangeButton = styled.button<{ wide?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: ${props => props.wide ? '5.5px 84px' : '8px 24px'};
  gap: 4px;
  background: #E1712A;
  border: 2px solid #E1712A;
  color: #FFFFFF;
  font-weight: 900;
  font-size: 14px;
  line-height: 21px;
  white-space: nowrap;

  svg {
    width: 18px;
    height: 18px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

export const OrangeButtonOutlined = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 6px;
  gap: 4px;
  background-color: #fff;
  border: 2px solid #E1712A;
  color: #3D6666;
  font-weight: 900;
  font-size: 14px;
  line-height: 21px;
  white-space: nowrap;

  svg {
    width: 18px;
    height: 18px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

export const OrangeButtonSimpleText = styled.button`
  color: #E1712A;
  font-weight: 900;
  font-size: 16px;
  display: flex;
  align-items: center;
  background: inherit;
  border: none;
  gap: 6px;

  svg {
    min-width: 18px;
    min-height: 18px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

export const AdminPortalFirms = styled.main`
  width: 100%;
  height: 100%;
  padding: 100px 120px 64px;

  header {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;

    strong {
      color: #1F202C;
      font-weight: 900;
      font-size: 16px;
      line-height: 24px;
    }

    .pill-buttons-container {
      display: flex;
      gap: 16px;
    }
  }

  section {
    margin-top: 28px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  footer {
    margin-top: 64px;
  }
`

export const GoldenText = styled.span`
  color: #937251;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`

export const OrangeText = styled.span`
  color: #E1712A;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`

export const AdminFirmViewContainer = styled.div`
  width: 100%;
  padding: 48px 120px;
  display: flex;
  flex-direction: column;
`

export const FirmViewHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  && aside {
    width: 100%;
    background: inherit;

    h1 {
      font-family: 'Tiempos', serif;
      font-style: normal;
      font-weight: 800;
      font-size: 36px;
      line-height: 57px;
      color: #353744;
    }

    h2 {
      font-family: 'Avenir', sans-seriff;
      font-weight: 500;
      font-size: 24px;
      line-height: 24px;
      color: #7B7C82;
    }
  }

  a {
    color: #E1712A;
    font-weight: 900;
    font-size: 18px;
    line-height: 27px;
    text-decoration-color: #E1712A;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
  }
`

export const AdminFirmViewSectionTitle = styled.h4`
  color: #7B7C82;
  font-weight: 900;
  font-size: 20px;
  line-height: 28px;
`

export const FirmViewSectionContainer = styled.div`
  background: #FFFFFF;
  border: 1px solid #CED8D8;
  border-radius: 2px;
  padding: 32px 40px;
  width: 100%;

  hr {
    width: 100%;
    border: 0.5px solid #EFEFEF;
  }

  h1 {
    color: #3D6666;
    font-weight: 900;
    font-size: 24px;
    line-height: 33px;
    font-family: 'Avenir', sans-seriff;
  }

  h2 {
    font-weight: 900;
    font-size: 28px;
    line-height: 38px;
    color: #353744;

    small {
      font-weight: 900;
      font-size: 14px;
      line-height: 21px;
      color: #7B7C82;
    }
  }

  h4 {
    color: #7B7C82;
    font-weight: 900;
    font-size: 18px;
    line-height: 25px;
  }

  h5 {
    color: #7B7C82;
    font-weight: 900;
    font-size: 14px;
    line-height: 19px;

    display: flex;
    align-items: center;
    gap: 6px;

    svg {
      min-width: 14px;
      min-height: 14px;
    }
  }

  h5 + h2 {
    margin-top: 8px;
  }

  h6 {
    font-weight: 800;
    font-size: 18px;
    line-height: 24px;
    color: #353744;
  }

  table {
    width: 100%;

    th {
      text-align: left;  
      color: #353744;
      font-weight: 900;
      font-size: 14px;
      line-height: 19px;
    }

    td {
      padding-top: 4px;
      color: #65666A;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }

  article {
    display: flex;
    flex-direction: column;

    strong {
      color: #353744;
      font-weight: 900;
      font-size: 14px;
      line-height: 19px;
    }

    span {
      color: #353744;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }

    strong + span {
      margin-top: 4px;
    }
  }

  article + article {
    margin-top: 20px;
  }

  @media only screen and (max-width: 640px) {
    .contact-item {
      flex-direction: column;
      gap: 12px;
    }

    button {
      width: 100%;
    }
  }
`

export const FirmAdministratorBadge = styled.div`
  background: #D4EEEE;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px;

  svg {
    color: #1F202C;
  }

  span {
    font-weight: 900;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: #1F202C;
    opacity: 0.7;
  }
`

export const PastDueMessageContainer = styled.div`
  && {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #E84242;

    svg {
      max-width: 8px;
      max-height: 8px;
    }
    
    span {
      font-weight: 800;
      font-size: 12px;
      line-height: 18px; 
      color: #E84242;
    }
  }
`